var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    _vm._b(
      {
        tag: "component",
        staticClass: "drag--drag-target",
        class: _vm.classes,
        attrs: { "drag-target": "drag-target" },
      },
      "component",
      Object.assign({}, _vm.$props, _vm.$attrs),
      false
    ),
    [
      _vm.showOverlay
        ? _c(
            "div",
            { staticClass: "drag--overlay-wrap" },
            [
              _vm._t("overlay", function () {
                return [
                  _c("div", { staticClass: "drag--overlay" }, [
                    _c("div", { staticClass: "drag--overlay-inner" }, [
                      _vm._v("Drop Here"),
                    ]),
                  ]),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }